import { slotsCentralAgentId } from './chatAgentIdentity';

// The tenant's configured roster is authoritative. Historical message senders
// remain in history, but must not become active routing/recall options.
export const configuredChatAgents = (agents, tenantId, central = false) => {
  const options = new Map();
  (Array.isArray(agents) ? agents : []).forEach(agent => {
    if (!agent || agent.enabled === false) return;
    const rawId = String(agent.id || agent.agent_id || '').trim();
    const name = String(agent.name || agent.agent_name || '').trim();
    if (!rawId && !name) return;
    const id = central ? slotsCentralAgentId(rawId, tenantId) : rawId;
    const key = name ? `name:${name.toLowerCase()}` : `id:${id}`;
    if (!options.has(key)) options.set(key, {
      key, id, name: name || 'Support Agent',
      title: agent.title || agent.agent_title || '',
      avatar_url: agent.avatar_url || '', bio: agent.bio || '',
    });
  });
  return [...options.values()].sort((a, b) => a.name.localeCompare(b.name));
};

// A receipt describes confirmed messages rendered in one conversation/stream.
// Do not acknowledge another room or an optimistic message that has no server ID.
export const staffReadAcknowledgement = (messages, roomId, agent = null) => {
  const renderedIds = [...new Set((messages || [])
    .filter(message => message?.conversation_id === roomId
      && typeof message.id === 'string' && message.id.length <= 160
      && message.id && !message.id.startsWith('temp_'))
    .map(message => message.id))].slice(-500);
  if (!roomId || !renderedIds.length) return null;
  return {
    last_message_id: renderedIds[renderedIds.length - 1],
    rendered_message_ids: renderedIds,
    ...(agent?.id ? { agent_id: agent.id } : {}),
    ...(agent?.name ? { agent_name: agent.name } : {}),
  };
};
